import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { App } from '../../modules/App';
import { ValidationRules } from '../../modules/ValidationRules';
import { SortFilter } from '../../modules/SortFilter';
import { SettingsUser } from '../SettingsUser';

export const Settings = (function () {
  let $dataGrid;
  const dataGridColumns = [
    { title: $Lang.user.userName, data: 'userName' },
    { title: $Lang.user.fullName, data: 'fullName' },
    { title: $Lang.user.email, data: 'email' },
    {
      title: $Lang.user.userGroup,
      data: 'selectedUserGrop',
      render: (data, type, full) => {
        return data && data.title ? data.title : ``;
      }
    },
    {
      title: 'Accounts',
      data: 'selectedAccounts',
      render: (data, type, full) => {
        const getSubAccounts = ({ accountName, subAccounts }) => {
          let result = [];

          if (accountName && Array.isArray(subAccounts)) {
            result = subAccounts.length
              ? subAccounts
                  .filter(({ accountName: subName }) => subName)
                  .map(({ accountName: subName }) => `${accountName} - ${subName}`)
              : [`${accountName} - All`];
          }

          return result;
        };

        const getAccounts = (accounts) =>
          accounts
            .map((account) => getSubAccounts(account))
            .flat()
            .join(', ');

        return Array.isArray(data) && data.length ? getAccounts(data) : '';
      }
    },
    {
      title: $Lang.user.creationDate,
      data: 'createdDate',
      render: (data, type, full) => {
        return data ? `<span class>${moment(data).format($config.appFullDateFormat)}</span>` : ``;
      }
    },
    {
      title: $Lang.user.lastModifiered,
      data: 'lastModifiered',
      render: (data, type, full) => {
        return data ? `<span class>${moment(data).format($config.appFullDateFormat)}</span>` : ``;
      }
    },
    {
      data: null,
      render: (data, type, row) => {
        return `<a href="/settings/${row.id}/edit" class="link-with-icon"><i class="fal fa-edit"></i>${$Lang.btn.edit}</a>`;
      },
      responsivePriority: 1
    },
    {
      data: null,
      orderable: false,
      sortable: false,
      searchable: false,
      render: (data, type, row) => {
        return `<a href="javascript:" data-id="${row.id}" onclick="bbApp.Settings.deleteUser('${row.id}')" class="link-with-icon js-action-deleteuser"><i class="fal fa-trash-alt text-danger fa-lg ml-1"></i>${$Lang.btn.delete}</a>`;
      },
      responsivePriority: 2
    },
    {
      orderable: false,
      data: null,
      sortable: false,
      className: '',
      responsivePriority: 0,
      render: (data, type, full) => {
        return (
          '<a href="javascript:" data-id="' +
          full.id +
          '" class="details-control"><i class="fas fa-caret-circle-down fa-lg"></i></a>'
        );
      }
    }
  ];

  const mapping = {
    users: (data) => {
      return data.map((item) => {
        item.DT_RowId = item.id;
        return item;
      });
    }
  };

  const settingsUserPage = (params) => {
    SettingsUser.init(params);
  };

  const init = (params = {}, query = '') => {
    if (params?.action && params?.id) {
      return settingsUserPage(params);
    }
    let template = require('./tmpl/settings.hbs');
    UI.page(template, {}).then(dataGridInit);
  };

  const dataGridAjaxData = (data, callback) => {
    let sendData = {
      pageLimit: data.length,
      page: data.start / data.length + 1,
      requestPage: 'settings'
    };
    $.when(App.ajaxData('settings/filter', sendData, 'POST')).done((res) => {
      if (!SortFilter.isInit('#settingsFilters')) {
        SortFilter.init({
          selector: '#settingsFilters',
          update: () => {
            $dataGrid.draw();
          }
        });
      }

      callback({
        recordsTotal: res.totalCount || 0,
        recordsFiltered: res.totalCount || 0,
        data: mapping.users(res.data)
      });
    });
  };

  const dataGridInit = () => {
    UI.block('#page');
    $dataGrid = $('#usersDataTable').DataTable({
      order: [3, 'desc'],
      ajax: dataGridAjaxData,
      columns: dataGridColumns,
      serverSide: true,
      responsive: {
        details: {
          type: 'column',
          target: -1
        }
      },
      stateSave: true,
      cache: false,
      searching: false,
      ordering: false,
      processing: true,
      dom: '<"row"<"col text-right"p>><"row"<"col-sm-12"t>><"row"<"col-sm-12 text-right"p>>',
      initComplete: pageInit
    });
  };

  const pageInit = () => {
    $('#page')
      .off()
      .on('click', '.js-action-deleteuser', deleteUser)
      .on('click', '.js-action-adduser', () => {
        UI.offPageLeaveHandler();
        $router.push(`/settings/0/add`);
      });
    UI.unblock('#page');
  };

  const dialogHandler = (e) => {
    let target = $(e.target).hasClass('js-action-edituser') ? $(e.target) : $(e.target).closest('.js-action-edituser');
    let id = target.data('id');
    editUserDialog(id);
  };

  let editUserDialog = (id = false, callback = false, currentAccount) => {
    let requestUrl = id ? `/settings/users/${id}` : `/settings/emptyUser`;
    UI.block('#page');
    $.when(App.ajaxData(requestUrl))
      .done((res) => {
        if (res.isSuccess) {
          let obj = res.createdObject;
          openDialog(obj, callback, id, currentAccount);
        }
      })
      .always((error) => {
        UI.unblock('#page');
      });
  };

  let openDialog = (user = {}, callback, id, currentAccount) => {
    let template = require('./tmpl/dialog/settingUser.hbs');
    bootbox
      .dialog({
        title: id ? 'Edit User' : 'Add User',
        message: template({ user: user, $lang: $lang, isEdit: !!id }),
        size: 'large',
        buttons: {
          Ok: {
            label: '<i class="fal fa-save"></i> Save',
            className: 'btn btn-brand',
            callback: (event) => userDialogFormSubmit(event, callback, currentAccount)
          },
          Close: {
            label: 'Close',
            className: 'btn btn-link'
          }
        }
      })
      .init(dialogInit(id));
  };

  let dialogInit = (id) => {
    let $form = $('#settingUserDialogForm');
    let $passwordIcons = $('#settingUserDialogForm .js-toggle-show-pass');

    const switchPasswordHandler = (e) => {
      if (e.target?.classList?.contains('fa-eye-slash')) {
        e.target.classList.remove('fa-eye-slash');
        e.target.classList.add('fa-eye');
        e.target.parentNode.parentNode.parentNode.querySelector('input').type = 'text';
      } else if (e.target?.classList?.contains('fa-eye')) {
        e.target.classList.remove('fa-eye');
        e.target.classList.add('fa-eye-slash');
        e.target.parentNode.parentNode.parentNode.querySelector('input').type = 'password';
      }
    };
    if (!id) {
      $passwordIcons.removeClass('fa-eye-slash');
      $passwordIcons.addClass('fa-eye');
      $passwordIcons.each(function () {
        $(this).parent().parent().parent().find('input').attr('type', 'text');
      });
    }
    $passwordIcons.on('click', (e) => switchPasswordHandler(e));

    $('[name="userGroups"]', $form).select2({
      tags: true,
      maximumSelectionLength: 1
    });

    $form.validate({ rules: ValidationRules.userCreateFrom });
  };

  let deleteUser = (e) => {
    let target = $(e.target).hasClass('js-action-deleteuser')
      ? $(e.target)
      : $(e.target).closest('.js-action-deleteuser');
    let id = target.data('id');
    if (!id) return;

    let name = $dataGrid?.row(`#${id}`).data()?.fullName || '';

    UI.deleteConfirm(name).then(() => {
      UI.block('#settingUserDialogForm');
      $.when(App.ajaxData('settings/user/delete', { userId: id }, 'POST'))
        .done((res) => {
          UI.notify({
            text: $lang.settings.userDeleted,
            icon: 'fal fa-check-circle',
            type: 'success'
          });
          $dataGrid.draw();
        })
        .always((error) => {
          UI.unblock('#settingUserDialogForm');
        });
    });
  };

  let userDialogFormSubmit = (event, callback = false, currentAccount) => {
    let $form = $('#settingUserDialogForm');
    let formData = $form.serializeObject();

    if (!$form.valid()) return false;

    // Selected User Group
    let userGroupsObj = $('[name="userGroups"]').select2('data')[0];
    formData.selectedUserGrop = { id: userGroupsObj.id, title: userGroupsObj.text };
    delete formData.userGroups;

    UI.block('#page');

    let url = formData.id ? `settings/user/updateWithoutAccounts` : `settings/user/create`;

    const newFormData = formData.id
      ? formData
      : { ...formData, selectedAccounts: [{ ...currentAccount, subAccounts: [] }] };

    $.when(App.ajaxData(url, newFormData, 'POST')) //Getting Brands list
      .done((res) => {
        if (res.isSuccess) {
          UI.notify({
            text: $lang.alert.SuccessfullySaved,
            icon: 'fal fa-check-circle',
            type: 'success'
          });

          if (!callback && $dataGrid) {
            $dataGrid.draw();
          } else {
            callback(res);
          }
        }
      })
      .always((error) => {
        UI.unblock('#page');
      });
  };

  return {
    init,
    editUserDialog,
    deleteUser
  };
})();
